import script from "./ForceIndex.vue?vue&type=script&lang=js"
export * from "./ForceIndex.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__